(function () {
    function loadScript(url, callback) {
        var script = document.createElement('script');
        script.src = url;
        script.async = false; // preserve execution order
        script.onload = callback;
        script.onerror = function () {
            console.error("Failed to load script:", url);
        };
        document.head.appendChild(script);
    }

    // Load GSAP (make sure URL is valid)
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/gsap.min.js", function () {
        console.log("✅ GSAP loaded");

        // Load MotionPathPlugin
        loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/MotionPathPlugin.min.js", function () {
            console.log("✅ MotionPathPlugin loaded");

            gsap.registerPlugin(MotionPathPlugin);

            function initMotionPathAnimations(container) {
                console.log("🔄 initMotionPathAnimations called on", container);
                const motions = container.getElementsByClassName('motion-animation');
                const tween = [];

                if (!motions.length) {
                    console.warn("⚠️ No .motion-animation elements found.");
                    return;
                }

                Array.from(motions).forEach((el, index) => {
                    const faceElement = el.querySelector('.face');
                    const motionPath = el.querySelector('.motionpath');

                    if (!faceElement || !motionPath) {
                        console.warn("Missing .face or .motionpath in", el);
                        return;
                    }

                    console.log(`Creating tween #${index}`);
                    tween[index] = gsap.to(faceElement, {
                        motionPath: {
                            path: motionPath,
                            align: motionPath,
                            alignOrigin: [0.5, 0.5],
                            autoRotate: false,
                            start: 0.008,
                            end: 0.991
                        },
                        duration: 14,
                        ease: 'cubic-bezier(.17,.67,.83,.67)'
                    }).pause(0.001);
                });

                if (tween[0]) {
                    window.addEventListener('scroll', function onScroll() {
                        if (window.pageYOffset >= 150) {
                            console.log("▶️ Playing first tween");
                            tween[0].play();
                            window.removeEventListener('scroll', onScroll);
                        }
                    });
                }

                const part2 = container.querySelector('.motion-path-wrapper-part2');
                if (part2 && tween[1]) {
                    const observer = new IntersectionObserver((entries, obs) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                console.log("▶️ Playing second tween");
                                tween[1].play();
                                obs.unobserve(entry.target);
                            }
                        });
                    }, { rootMargin: '150px', threshold: 1.0 });
                    observer.observe(part2);
                }
            }

            document.addEventListener('DOMContentLoaded', () => initMotionPathAnimations(document));
            document.addEventListener('shopify:section:load', e => setTimeout(() => initMotionPathAnimations(e.target), 300));
            document.addEventListener('shopify:section:select', e => setTimeout(() => initMotionPathAnimations(e.target), 300));
        });
    });
})();
// Initial run
initMotionPathAnimations(document);

// Also hook into Shopify events
document.addEventListener('shopify:section:load', function (event) {
  initMotionPathAnimations(event.target);
});
document.addEventListener('shopify:section:select', function (event) {
  initMotionPathAnimations(event.target);
});